import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';

export const entWebsiteInsightsFragment = contentfulGql`#graphql
   fragment EntWebsiteInsights on EntWebsiteInsights {
    heading
    subheading
    slug
    cardsCollection {
      items {
        headline
        body
        icon {
          url
          description
          width
          height
        }
      }
    }
  }
`;

export const entWebsiteBlockInsightsQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteInsightsFragment}
  query entWebsiteBlockInsights($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteInsights
      }
    }
  }
`;
